import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, catchError, map, mergeMap, of, switchMap } from 'rxjs';

import { Action } from '@ngrx/store';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { getAllUsers, getAllUsersFailure, getAllUsersSuccess } from './actions';
import { setSharedData } from '../shared/actions';
import { UserService } from 'src/app/services/common-services/user.service';

@Injectable()
export class UsersStoreEffects {
  constructor(
    private actions$: Actions,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: MatDialog,
    private userService: UserService,
  ) {}

  getAllUsersEffect$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(getAllUsers),
      switchMap((action) =>
        this.userService.getAllUsers(action.data).pipe(
          mergeMap((res) => {
            return [getAllUsersSuccess({ data: res }), setSharedData({ data: res })];
          }),
          catchError((error) => {
            return of(getAllUsersFailure({ error }));
          }),
        ),
      ),
    );
  });
}
